import React from 'react';
import styles from './AdvtTop.module.css';
import { useGetParams } from '../../hooks/useGetParams';
import fullLogo from '../../assets/images/fullLogo.png';

const AdvtTop = React.memo(({ advtInfo }) => {
  const { paddingQR, sizeQR, title3FontSize } = useGetParams();

  const { label, qrCode1, qrCode2 } = advtInfo;

  return (
    <div className={styles.wrapperAdvtTop}>
      <img src={fullLogo} alt="fullLogo" className={styles.fullLogo} />

      {label && (
        <div className={styles.info}>
          <div
            className={styles.quizTitle}
            style={{ fontSize: `${title3FontSize * 2}rem` }}>
            КВИЗ
          </div>

          <div
            className={styles.title}
            style={{
              fontSize: `${title3FontSize}rem`,
              lineHeight: `${title3FontSize}rem`,
            }}>
            {label}
          </div>
        </div>
      )}

      <div className={styles.qrWrapper}>
        {qrCode1 && (
          <div
            className={styles.qrItem}
            style={{
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
              padding: `${paddingQR}rem`,
            }}>
            <img src={qrCode1} alt="" />
          </div>
        )}
        {qrCode2 && (
          <div
            className={styles.qrItem}
            style={{
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
              padding: `${paddingQR}rem`,
            }}>
            <img src={qrCode2} alt="" />
          </div>
        )}
      </div>
    </div>
  );
});

export default AdvtTop;
